enum BaseNameSideItem {
  DASHBOARD = 'Dashboard',
  MY_REQUESTS = 'My Requests',
  APPROVALS = 'Approvals',
  REPORTS = 'Reports',
  PROCUREMENT = 'Procurement',
  HOME = 'Home',
  SEARCH = 'Search',
  APPS = 'APPS',
  ESS = 'EmployeeSelfService',
  MR = 'MaterialRequest',
  MENU = 'Menu',
}

export default BaseNameSideItem;
